export default function() {
    return {
        symplaEvents: [],
        showDeleteConfirmationModal: false,
        deleteSymplaEvent: null,
        syncingEvent: null,
        messages: [],
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 15,
        fields: [
            {
                key: 'image',
                label: ''
            },
            {
                key: 'name',
                label: 'Nome'
            },
            {
                key: 'latestSymplaStatus',
                label: 'Status integração'
            },
            {
                key: 'totalParticipations',
                label: 'Usuários'
            },
            {
                key: 'showingParticipations',
                label: 'Perfis exibindo este curso'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
